import {
  FINES_PORTAL_NOTIFICATION_TYPE,
} from '../config/finesPortalNotification';
import { MultasFine } from '../pages/Multas/models/multas.types';

export function mapFinesToBellNotifications(
  fines: MultasFine[],
): notificationCentral {
  return fines.map(fine => {
    const plate = fine.plate ?? '';
    const ait = fine.aitCode ?? '';
    const description = fine.infractionDescription?.trim();
    const contentParts = [
      plate ? `Placa ${plate}` : null,
      ait ? `AIT ${ait}` : null,
      description || null,
    ].filter(Boolean);

    return {
      id: fine.fineId || ait || plate,
      type: FINES_PORTAL_NOTIFICATION_TYPE,
      plate,
      chassi: '',
      aitCode: ait,
      title: 'Multa notificada',
      content: contentParts.join(' · ') || 'Nova notificação de multa',
    };
  });
}
